<template>
  <div>
    <v-container grid-list-xl v-if="!collected">
      <v-dialog v-model="dialogProgress" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text class="pa-5">
            Please stand by
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-layout column>
        <v-flex v-if="Campaigns">
          <v-card flat>
            <v-stepper vertical v-model="step" class="elevation-0">
              <v-stepper-step class="pl-2" :complete="step > 1" step="1">
                <v-layout row justify-space-between>
                  <v-flex shrink> Sponsor </v-flex>
                  <v-flex shrin v-if="allRowTotal">
                    {{ allRowTotal | currency }}
                  </v-flex>
                </v-layout>
              </v-stepper-step>

              <v-stepper-content class="pl-1 pt-1 ml-5" step="1">
                <div>
                  <div style="height: 350px; overflow: auto" class="mb-2">
                    <v-list
                      dense
                      class="py-0"
                      v-for="(group, index) in groups"
                      :key="index"
                    >
                      <v-subheader>{{ group.category }}</v-subheader>
                      <v-list-item
                        two-line
                        v-for="(item, i) in group.items"
                        :key="i"
                      >
                        <v-list-item-action>
                          <v-btn
                            depressed
                            color="primary"
                            @click="plus(item)"
                            x-small
                            fab
                          >
                            <v-icon>mdi mdi-plus</v-icon>
                          </v-btn>
                        </v-list-item-action>

                        <v-list-item-content>
                          <v-list-item-title
                            v-text="item.name"
                          ></v-list-item-title>
                          <v-list-item-subtitle class="caption"
                            >{{ item.qty }}x
                            {{ item.amount | currency }}</v-list-item-subtitle
                          >
                        </v-list-item-content>

                        <v-list-item-action>
                          <v-btn
                            depressed
                            color="error"
                            :disabled="item.qty === 0 ? true : false"
                            @click="minus(item)"
                            x-small
                            fab
                          >
                            <v-icon>mdi mdi-minus</v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                  </div>
                  <v-card color="green lighten-4" class="py-2" flat>
                    <div class="text-center">
                      <span class="font-weight-bold">{{
                        (allRowTotal / 12) | currency
                      }}</span>
                      / month for 12 months
                    </div>
                  </v-card>
                </div>

                <v-divider class="mt-4"></v-divider>
                <v-card-actions>
                  <v-btn text @click="$router.go(-1)">Back</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    large
                    @click="infoStep"
                    :disabled="!allowStep2"
                    color="primary"
                    >Next</v-btn
                  >
                </v-card-actions>
              </v-stepper-content>

              <v-stepper-step class="pl-2" :complete="step > 2" step="2">
                Your Information
              </v-stepper-step>

              <v-stepper-content class="pl-1 pt-1 ml-5" step="2">
                <v-layout row wrap class="mt-2">
                  <v-flex xs12 sm6>
                    <v-text-field
                      autofocus
                      v-model="Donor.name"
                      :error-messages="nameErrors"
                      :hide-details="nameErrors.length === 0"
                      outlined
                      dense
                      label="Name"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      type="number"
                      :error-messages="phoneNumberErrors"
                      :hide-details="phoneNumberErrors.length === 0"
                      v-model="Donor.phoneNumber"
                      outlined
                      dense
                      label="Phone Number"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      v-model="Donor.email"
                      :error-messages="emailErrors"
                      :hide-details="emailErrors.length === 0"
                      outlined
                      dense
                      label="Email Address"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-divider class="mt-4"></v-divider>
                <v-card-actions>
                  <v-btn text @click="step = step - 1" large>Back</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn large @click="paymentInfo" color="primary">Next</v-btn>
                </v-card-actions>
              </v-stepper-content>

              <v-stepper-step class="pl-2" :complete="step > 3" step="3">
                Payment
              </v-stepper-step>

              <v-stepper-content class="pl-1 pt-1 ml-5" step="3">
                <v-col cols="12" class="py-2">
                  <div class="mb-2">Payment Cycle?</div>
                  <v-btn-toggle
                    @change="reCalculateFee"
                    dense
                    v-model="donationObj.paymentCycle"
                    color="primary"
                  >
                    <v-btn outlined small value="monthly"> Monthly </v-btn>

                    <v-btn outlined small value="oneTime"> One Time </v-btn>
                  </v-btn-toggle>
                </v-col>

                <v-col
                  v-if="donationObj.paymentCycle === 'monthly'"
                  cols="12"
                  class="text-caption text-md-body-1 text-lg-h6"
                >
                  We will collect a payment of
                  <span class="font-weight-bold">{{
                    (allRowTotal / 12) | currency
                  }}</span>
                  on the
                  <span class="font-weight-bold">{{
                    getFormattedDay(startingDate)
                  }}</span>
                  day of each month for a 12-month cycle. Starting from
                  <span class="font-weight-bold">{{
                    startingDate | moment("LL")
                  }}</span
                  >. At the end of the 12-month cycle, your sponsorship will
                  come to a close.
                </v-col>
                <v-col
                  v-else
                  cols="12"
                  class="text-caption text-md-body-1 text-lg-h6"
                >
                  We will collect a payment of
                  <span class="font-weight-bold">{{
                    allRowTotal | currency
                  }}</span>
                  on the
                  <span class="font-weight-bold">{{
                    startingDate | moment("LL")
                  }}</span
                  >. for whole year of sponsorship.
                </v-col>

                <CreditCard
                  v-if="step === 3"
                  @submit="infoCollect"
                  :localCollectOnly="true"
                  :donor="Donor"
                  :public="true"
                  :donationCategoryId="Business.DefaultDonationId"
                />

                <p class="mt-5" v-if="Business">
                  By clicking the "Submit" button, you are authorizing an
                  electronic fund transfer from the specified account for this
                  transaction in the specified amount to {{ Business.name }}.
                </p>

                <!-- :disabled="loading" :loading="loading" -->
                <v-divider class="mt-4"></v-divider>
                <v-card-actions>
                  <v-btn text @click="step = step - 1" large>Back</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    large
                    @click="submit"
                    :disabled="loading"
                    :loading="loading"
                    rounded
                    class="px-5"
                    color="primary"
                    ><span v-if="donationObj.paymentCycle === 'monthly'"
                      >Each Month</span
                    >
                    <span v-else>Donate</span
                    >{{ totalDonationAmount | currency }}</v-btn
                  >
                </v-card-actions>
              </v-stepper-content>
            </v-stepper>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container grid-list-lg :fluid="$vuetify.breakpoint.xsOnly" v-else>
      <v-card flat>
        <v-card-text>
          <lottie
            :height="200"
            :options="defaultOptions"
            name="receiptCheck"
            v-on:animCreated="handleAnimation"
            @onComplete="showHomeButton = true"
          />
          <div class="text-center">
            <div class="text-h5">All Set</div>
            <div class="mt-3">
              The Prophet, upon be peace, said: “The believer’s shade on the Day
              of Resurrection will be his charity.”
              <span class="font-weight-bold">Al-Tirmidhi</span>
            </div>
          </div>
          <div class="text-center mt-5" v-if="showHomeButton">
            <v-slide-y-transition>
              <v-btn block large @click="$router.go(-1)" color="success"
                >Home</v-btn
              >
            </v-slide-y-transition>
          </div>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import donationService from "@/modules/Campaign/service.js";
import CreditCard from "@/modules/PaymentMethod/components/CreditCard.vue";
import Lottie from "@/components/lottie.vue";
import * as animationData from "@/assets/lottie/1708-success.json";

const { validationMixin } = require("vuelidate");
const { required, email } = require("vuelidate/lib/validators");

const pjson = require("../../../../../package.json");
export default {
  name: "collectDonationBySponsor",
  data() {
    return {
      dialogProgress: false,
      donationLimit: false,
      paidInFullAmount: 0,
      allRowTotal: 0,
      donationSelectedAmount: 0,
      selectedRow: null,
      Donor: {
        name: null,
        phoneNumber: null,
        email: null,
      },
      dateFormatted: null,
      startingDate: this.$moment(),
      minDate: null,
      donationObj: {
        paymentType: "card",
        paymentCycle: "monthly",
        accountType: "personal",
        startingDate: this.$moment(),
      },
      groups: [],
      collected: false,
      card: null,
      showHomeButton: false,
      showSecondCollection: true,
      loading: false,
      feeAmount: 0,
      allowStep2: false,
      totalDonationAmount: 0,
      step: 1,
      selectedAmount: 0,
      amount: 10,
      paymentCycle: "monthly",
      Campaigns: null,
      Business: null,
      addFee: false,
      addFeeSecond: false,
      defaultOptions: {
        animationData: animationData.default,
        loop: false,
        autoplay: true,
      },
    };
  },
  created() {
    this.loadCampaign();
  },
  mixins: [validationMixin],
  validations: {
    Donor: {
      name: {
        required,
      },
      phoneNumber: {
        required,
      },
      email: {
        required,
        email,
      },
    },
  },
  components: {
    CreditCard,
    Lottie,
  },
  computed: {
    version() {
      return pjson.version;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.Donor.name.$dirty) return errors;
      if (!this.$v.Donor.name.required) errors.push("First Name is required");
      return errors;
    },
    phoneNumberErrors() {
      const errors = [];
      if (!this.$v.Donor.phoneNumber.$dirty) return errors;
      if (!this.$v.Donor.phoneNumber.required)
        errors.push("Phone Number is required");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.Donor.email.$dirty) return errors;
      if (!this.$v.Donor.email.required)
        errors.push("Email Address is required");
      if (!this.$v.Donor.email.email) errors.push("Email is not valid");
      return errors;
    },
  },
  watch: {
    allRowTotal(val) {
      if (val > 0) {
        this.allowStep2 = true;
      } else {
        this.allowStep2 = false;
      }
    },
    dialog(val) {
      if (val) {
        if (this.selectedRow.received) {
          this.paidInFullAmount =
            parseFloat(this.selectedRow.amount) -
            parseFloat(this.selectedRow.received);
        } else {
          this.paidInFullAmount = parseFloat(this.selectedRow.amount);
        }
      }
    },
    addFeeSecond() {
      console.log("click me");
      this.setDonationAmount();
    },
    addFee(val) {
      if (val) {
        this.showSecondCollection = false;
      } else {
        this.showSecondCollection = true;
      }
      this.setDonationAmount();
    },
    amount() {
      console.log("saqib test");
      this.setDonationAmount();
    },
    selectedAmount() {
      this.showOtherInput();
    },
    donationSelectedAmount(val) {
      // console.log('donationSelectedAmount', val)
      this.selectedRow.donationAmount = this.preDefinedValue[val];
    },
  },
  methods: {
    reCalculateFee() {
      const monthlyValue = this.allRowTotal / 12;
      if (this.donationObj.paymentCycle === "monthly") {
        this.feeAmount = ((parseFloat(monthlyValue) * 3.4) / 100 + 0.3).toFixed(
          2
        );
      } else {
        this.feeAmount = (
          (parseFloat(this.allRowTotal) * 3.4) / 100 +
          0.3
        ).toFixed(2);
      }

      if (this.addFee || this.addFeeSecond) {
        if (this.donationLimit) {
          this.totalDonationAmount =
            parseFloat(this.allRowTotal) + parseFloat(this.feeAmount);
        } else {
          if (this.donationObj.paymentCycle === "monthly") {
            this.totalDonationAmount =
              parseFloat(monthlyValue) + parseFloat(this.feeAmount);
          } else {
            this.totalDonationAmount =
              parseFloat(this.allRowTotal) + parseFloat(this.feeAmount);
          }
        }
      } else {
        if (this.donationObj.paymentCycle === "monthly") {
          this.totalDonationAmount = parseFloat(monthlyValue);
        } else {
          this.totalDonationAmount = parseFloat(this.allRowTotal);
        }
      }
    },
    getFormattedDay(date) {
      const dayOfMonth = this.$moment(date).date();
      const suffix = this.getDaySuffix(dayOfMonth);
      return dayOfMonth + suffix;
    },
    getDaySuffix(day) {
      if (day >= 11 && day <= 13) {
        return "th";
      }
      switch (day % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    plus(item) {
      item.qty += 1;
      // console.log('this.groups', this.groups)
      this.setDonationAmount();
    },
    minus(item) {
      item.qty -= 1;
      // console.log('this.groups', this.groups)
      this.setDonationAmount();
    },
    handleAnimation(anim) {
      this.anim = anim;
    },
    calculateReceivedingPercentage(receivedingAmount, totalAmount) {
      // Calculate the percentage
      let receive = 0;
      if (receivedingAmount) {
        receive = receivedingAmount;
      }
      const percentage = (receive / totalAmount) * 100;

      // Return the percentage, rounded to 2 decimal places
      return parseFloat(percentage.toFixed(0));
    },
    isActive(item) {
      let value = false;
      if (item.donationAmount > 0) {
        value = true;
      }
      return value;
    },
    close() {
      this.dialog = false;
      this.setDonationAmount();
    },
    groupByCategory(data) {
      const result = [];

      // Create an object to hold grouped items temporarily
      const temp = {};

      // Loop through the data array
      data.CampaignDetails.forEach((item) => {
        const { category, id, name, amount } = item;

        // If the category doesn't exist in the temp object, create an array for it
        if (!temp[category]) {
          temp[category] = [];
        }

        // Push the name and amount pair to the category array
        temp[category].push({ id, name, amount, qty: 0 });
      });

      // Convert temp object to array of objects
      for (const category in temp) {
        result.push({ category, items: temp[category] });
      }

      return result;
    },
    infoCollect(val) {
      this.card = val;
    },
    submit() {
      try {
        let data = {};
        data.Donor = this.Donor;

        this.$events.emit("submitCreditCard");
        data.donationLimit = this.donationLimit;
        data.cycle = this.paymentCycle;
        data.Donor = this.Donor;
        data.card = this.card;
        data.campaignType = this.Campaigns.type;
        data.CampaignId = this.Campaigns.id;
        data.selectedRow = [];

        if (this.addFee || this.addFeeSecond) {
          data.processingFeeCollect = true;
        } else {
          data.processingFeeCollect = false;
        }
        this.groups.map((cateogryRow) => {
          console.log("cateogry", cateogryRow);
          cateogryRow.items.map((row) => {
            console.log("founded before", row);
            if (row.qty > 0) {
              console.log("founded", row);
              row.fullName = row.name.concat(" ", cateogryRow.category);
              data.selectedRow.push(row);
            }
          });
        });
        data.amount = this.allRowTotal;

        data.feeAmount = this.feeAmount;

        if (data.processingFeeCollect) {
          data.finalAmount =
            parseFloat(data.amount) + parseFloat(data.feeAmount);
        } else {
          data.finalAmount = parseFloat(data.amount);
        }

        data.CampaignId = this.Campaigns.id;

        console.log("data collected", this.Campaigns);
        console.log("data collected data", data);

        if (!data.card) {
          return false;
        }
        this.loadingSubmit = true;
        this.loading = true;
        this.dialogProgress = true;
        donationService
          .publicDonationSponsor(this.Business.code, data)
          .then((response) => {
            console.log("response publicSponsorCreate", response);
            this.loadingSubmit = false;
            this.collected = true;
            this.loading = false;
          })
          .catch((error) => {
            this.loadingSubmit = false;
            this.loading = false;
            this.dialogProgress = false;
            console.log("err", error);
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: error.data.message,
              });
          });
      } catch (error) {
        this.dialogProgress = false;
        this.loadingSubmit = false;
        this.loading = false;
        console.log("error adding card3", error);
      }
    },
    paymentInfo() {
      this.$v.Donor.$touch();
      if (this.$v.Donor.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.step = 3;
      }
    },
    showOtherInput() {
      this.amount = this.preDefinedValue[this.selectedAmount];
    },
    setDonationAmount() {
      if (this.step === 1 && this.groups.length) {
        this.allRowTotal = 0;
        this.groups.map((category) => {
          category.items.map((row) => {
            this.allRowTotal += parseFloat(row.amount) * row.qty;
          });
        });
      }
      this.feeAmount = 0;
      this.reCalculateFee();
    },
    infoStep() {
      this.step = 2;
    },
    loadCampaign() {
      let code = this.$route.params.id;
      console.log("getting code 22", this.$route.params);
      donationService
        .getCampaignById(code)
        .then((response) => {
          console.log("response campaign", response);
          // if (!response.data) {
          //   this.$router.push({ name: "pagenotfound" });
          // }
          this.Campaigns = response.data;
          this.Business = response.data.Business;
          console.log("test", this.Campaigns.metadata.preDefinedValue);
          if (this.Campaigns?.metadata?.preDefinedValue.length) {
            this.preDefinedValue = this.Campaigns.metadata.preDefinedValue;
            this.amount = this.preDefinedValue[0];
          }
          if (
            this.Campaigns &&
            this.Campaigns.metadata &&
            this.Campaigns.metadata.donationLimit
          ) {
            this.donationLimit = true;
          }

          this.groups = this.groupByCategory(this.Campaigns);
          console.log("this.groups", this.groups);
        })
        .catch((error) => {
          console.log("error getting campaign", error);
          // this.$router.push({ name: "pagenotfound" });
        });
    },
  },
};
</script>

<style scoped>
.selectedRow {
  background: #b2dfdb;
  font-weight: 900 !important;
}

.paidRow {
  background: #e1bee7;
  /* font-weight: 900 !important; */
}

.receiveMoney {
  background: #e8f5e9;
  /* font-weight: 900 !important; */
}
</style>../../../../../package.json